const getTopicId = state => state.player.view.topicId;

export default getTopicId;
